import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';

import { jqxTreeComponent } from 'jqwidgets-ng/jqxtree';
import { jqxLoaderComponent } from 'jqwidgets-ng/jqxloader';
import { environment } from '../../../environments/environment';
import {
  MenuModel,
  MenuOptionsModel,
} from '../../services/sso/models/menu.model';
import { MenuService } from '../../services/menu/menu.service';
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { AccionModel } from 'src/app/services/sso/models/menu.accion.model';
import { MainComponent } from '../main/main.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { jqxButtonComponent } from 'jqwidgets-ng/jqxbuttons';
import { CrudService } from 'src/app/services/crud/crud.service';
import { TextoModel } from 'src/app/services/sso/models/texto.model';

@Component({
  selector: 'app-custom-menu',
  templateUrl: './edit-menu.component.html',
  styleUrls: ['./edit-menu.component.css'],
})
export class EditMenuComponent implements OnInit, AfterViewInit {
  @ViewChild('loader') loader: jqxLoaderComponent;
  @ViewChild('menuOrigin') menuOrigin: jqxTreeComponent;
  @ViewChild('menuFinal') menuFinal: jqxTreeComponent;
  @ViewChild('menuOld') menuOld: jqxTreeComponent;
  @ViewChild('menuDel') menuDel: jqxTreeComponent;
  @ViewChild('ebNombre') ebNombre: jqxInputComponent;
  @ViewChild('ebObserv') ebObserv: jqxInputComponent;
  @ViewChild('grid') grid: jqxGridComponent;
  @ViewChild('cbAcciones') cbAcciones: jqxDropDownListComponent;
  @ViewChild('cbAccionOpcion') cbAccionOpcion: jqxDropDownListComponent;
  @ViewChild('cbTextoOpcion') cbTextoOpcion: jqxDropDownListComponent;
  @ViewChild('btnMas') btnMas: jqxButtonComponent;
  @ViewChild('chbHermana') chbHermana: any;
  @ViewChild('chbHija') chbHija: ElementRef;
  @ViewChild('chbSoloMovisat') chbSoloMovisat: ElementRef;
  @ViewChild('chbVerMenuOld') chbverMenuOld: ElementRef;

  private componentRef = null;
  public environment = environment;

  // Variables para grid y dropdownlist
  public dataSource;
  public dataAdapter;
  public dataSourceOri;
  public dataAdapterOri;
  public dataSourceFin;
  public dataSourceOld;
  public dataAdapterFin;
  public dataAdapterOld;
  public accionSource;
  public accionesAdapter;
  public recordsOri;
  public recordsFin;
  public recordsOld;
  public menus: MenuModel[] = [];
  public menusOld: MenuModel[] = [];
  public acciones: AccionModel[] = [];
  public textos: TextoModel[] = [];
  public menuSelecId = 0;
  public menuSelec: MenuModel = null;
  public opcionSelec: MenuOptionsModel = null;
  public rowIndexSelec = 0;
  public opcVisible = false;
  public imageDelete = '/assets/images/btnDelete.png';
  public textoSeleccionado = '';
  public observacionesAccion = '';
  public verMenuOld = false;
  public idsOriginales = new Map<string, number>();
  public accionesHash = new Map<string, AccionModel>();

  // Preparo las columnas del grid
  public columns = [
    {
      text: 'Nombre',
      columntype: 'textbox',
      filtertype: 'textbox',
      datafield: 'nombre',
      width: 210,
      aggregates: [
        {
          Total: function (aggregatedValue, currentValue: number) {
            return aggregatedValue + 1;
          },
        },
      ],
      aggregatesrenderer: function (aggregates) {
        let renderstring = '';
        if (aggregates['Total'] !== undefined) {
          renderstring =
            '<div style="margin-left: 4px;">Total: ' +
            aggregates['Total'] +
            '</div>';
        }
        return renderstring;
      },
    },
    {
      text: 'Observaciones',
      columntype: 'textbox',
      filtertype: 'textbox',
      datafield: 'observ',
      width: 390,
    },
  ];

  //  Esto es para que los textos en los controles del grid salgan en español
  public langGrid = JqWidgets.getLocalization('es');

  constructor(
    private menuService: MenuService,
    private crudService: CrudService,
    private modal: NzModalService,
  ) {}

  ngOnInit(): void {}

  async ngAfterViewInit() {
    this.loader.open();
    await this.getAcciones();
    await this.getMenus();
    await this.getTextos();
    this.initMenuOri();
    this.loader.close();
  }

  // Este método es llamado por el creador del componente
  public init(componentRef: any) {
    this.componentRef = componentRef;
  }

  async getAcciones() {
    try {
      this.acciones = await this.menuService.getActions();
      if (this.acciones) {
        this.acciones.forEach((accion) => {
          this.accionesHash.set(accion.Id, accion);
        });
      }

      // Relleno el combo de acciones
      this.cbAcciones.clear();
      this.cbAccionOpcion.clear();
      const source: any = [];
      this.acciones.forEach((accion) => {
        source.push({ label: accion.Id, value: accion.Id });
      });
      this.cbAcciones.source(source);
      this.cbAccionOpcion.source(source);
      this.cbAcciones.selectIndex(0);
      this.cbAccionOpcion.selectIndex(0);
    } catch (e) {
      console.log(e);
    }
  }

  async getTextos() {
    try {
      this.textos = await this.crudService.getTextos(1);
      // Relleno el combo de textos
      this.cbTextoOpcion.clear();
      const source: any = [];
      this.textos.forEach((texto) => {
        source.push({ label: texto.Id, value: texto.Id });
      });
      this.cbTextoOpcion.source(source);
      // this.cbTextoOpcion.selectIndex(0);
    } catch (e) {
      console.log(e);
    }
  }

  // Obtiene los menus
  async getMenus() {
    try {
      this.menus = await this.menuService.getMenus();
      if (this.menus) {
        this.dataSource = {
          datatype: 'json',
          datafields: [
            { name: 'nombre', type: 'string', map: 'Nombre' },
            { name: 'observ', type: 'string', map: 'Observaciones' },
          ],
          localdata: this.menus,
          sortcolumn: 'nombre',
          sortdirection: 'asc',
        };
        this.dataAdapter = new jqx.dataAdapter(this.dataSource);
        this.menusOld = [];
        this.menus.forEach((menu) => {
          this.menusOld.push(menu);
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  initMenuOri() {
    this.dataSourceOri = {
      datatype: 'json',
      datafields: [
        { name: 'Id', type: 'string', map: 'Id' },
        { name: 'PadreId', type: 'string', map: 'PadreId' },
        { name: 'TextoId', type: 'string', map: 'TextoId' },
        { name: 'Orden', type: 'string', map: 'Orden' },
        { name: 'AccionId', type: 'string', map: 'AccionId' },
      ],
      id: 'Id',
      localdata: this.menus[0].Opciones,
    };
    this.dataAdapterOri = new jqx.dataAdapter(this.dataSourceOri, {
      autoBind: true,
    });
    this.recordsOri = this.dataAdapterOri.getRecordsHierarchy(
      'Id',
      'PadreId',
      'items',
      [
        { name: 'Id', map: 'id' },
        { name: 'TextoId', map: 'label' },
        { name: 'AccionId', map: 'value' },
      ],
    );
    if (!this.recordsOri) {
      this.recordsOri = [];
    }
    // Coloco los tooltips con el texto
    const t = setTimeout(() => {
      clearTimeout(t);
      if (this.menuOrigin) {
        const items: any = this.menuOrigin.getItems();
        if (items) {
          items.forEach((element) => {
            element.OpcionOriginalId = element.id;
            const ti = this.textos.find((x) => x.Id === element.label);
            element.titleElement.attr('title', ti ? ti.Texto : '');
          });
        }
      }
    }, 1000);
  }

  initMenuEdit(index: number) {
    this.dataSourceFin = {
      datatype: 'json',
      datafields: [
        { name: 'Id', type: 'string', map: 'Id' },
        { name: 'PadreId', type: 'string', map: 'PadreId' },
        { name: 'TextoId', type: 'string', map: 'TextoId' },
        { name: 'Orden', type: 'string', map: 'Orden' },
        { name: 'AccionId', type: 'string', map: 'AccionId' },
        { name: 'SoloMovisat', type: 'boolean', map: 'SoloMovisat' },
      ],
      id: 'Id',
      localdata: this.menus[index].Opciones,
    };
    this.dataAdapterFin = new jqx.dataAdapter(this.dataSourceFin, {
      autoBind: true,
    });
    this.recordsFin = this.dataAdapterFin.getRecordsHierarchy(
      'Id',
      'PadreId',
      'items',
      [
        { name: 'Id', map: 'id' },
        { name: 'TextoId', map: 'label' },
        { name: 'AccionId', map: 'value' },
        { name: 'SoloMovisat', map: 'checked' },
      ],
    );
    if (!this.recordsFin) {
      this.recordsFin = [];
    }
    this.idsOriginales.clear();
    this.menus[index].Opciones.forEach((opt) => {
      this.idsOriginales.set('' + opt.Id, opt.OpcionOriginalId);
    });
    // Coloco los tooltips con el texto
    setTimeout(() => {
      const items: any = this.menuFinal.getItems();
      if (items) {
        items.forEach((element) => {
          element.OpcionOriginalId = this.idsOriginales.get(element.id);
          const ti = this.textos.find((x) => x.Id === element.label);
          element.titleElement.attr('title', ti ? ti.Texto : '');
        });
      }
    }, 1000);
  }

  initMenuOld(index: number) {
    this.dataSourceOld = {
      datatype: 'json',
      datafields: [
        { name: 'Id', type: 'string', map: 'Id' },
        { name: 'PadreId', type: 'string', map: 'PadreId' },
        { name: 'TextoId', type: 'string', map: 'TextoId' },
        { name: 'Orden', type: 'string', map: 'Orden' },
        { name: 'AccionId', type: 'string', map: 'AccionId' },
        { name: 'SoloMovisat', type: 'boolean', map: 'SoloMovisat' },
      ],
      id: 'Id',
      localdata: this.menusOld[index].Opciones,
    };
    this.dataAdapterOld = new jqx.dataAdapter(this.dataSourceOld, {
      autoBind: true,
    });
    this.recordsOld = this.dataAdapterOld.getRecordsHierarchy(
      'Id',
      'PadreId',
      'items',
      [
        { name: 'Id', map: 'id' },
        { name: 'TextoId', map: 'label' },
        { name: 'AccionId', map: 'value' },
        { name: 'SoloMovisat', map: 'checked' },
      ],
    );
    if (!this.recordsOld) {
      this.recordsOld = [];
    }
    // Coloco los tooltips con el texto
    setTimeout(() => {
      const items: any = this.menuOld.getItems();
      if (items) {
        items.forEach((element) => {
          const ti = this.textos.find((x) => x.Id === element.label);
          element.titleElement.attr('title', ti ? ti.Texto : '');
        });
      }
    }, 1000);
  }

  onRowSelect(event: any) {
    this.menuSelec = this.menus[event.args.rowindex];
    this.menuSelecId = this.menuSelec.Id;
    this.initMenuEdit(event.args.rowindex);
    this.initMenuOld(event.args.rowindex);
    this.rowIndexSelec = event.args.rowindex;
    this.opcionSelec = null;
    this.cbAcciones.selectedIndex(0);
    this.ebNombre.val(this.menuSelec.Nombre);
    this.ebObserv.val(this.menuSelec.Observaciones);
    if (this.chbSoloMovisat && this.chbSoloMovisat.nativeElement) {
      this.chbSoloMovisat.nativeElement.checked = false;
    }
    if (this.chbverMenuOld && this.chbverMenuOld.nativeElement) {
      this.chbverMenuOld.nativeElement.checked = false;
    }
    this.verMenuOld = false;
  }

  onSelectOpciones(event: any) {
    const args = event.args;
    const item: any = this.menuFinal.getItem(args.element);
    if (item) {
      this.idsOriginales.set('' + item.id, item.OpcionOriginalId);
      this.chbSoloMovisat.nativeElement.checked = item.checked;
      if (this.menuSelec.Opciones && this.menuSelec.Opciones.length > 0) {
        for (let i = 0; i < this.menuSelec.Opciones.length; i++) {
          if (item.id === '' + this.menuSelec.Opciones[i].Id) {
            this.opcionSelec = this.menuSelec.Opciones[i];
            break;
          }
        }
      }
      if (item.label) {
        this.textoSeleccionado = this.textos.find(
          (x) => x.Id === item.label,
        ).Texto;
      }
      if (item.value) {
        const acciones = this.cbAcciones.getItems();
        if (acciones) {
          for (let i = 0; i < acciones.length; i++) {
            if (item.value === acciones[i].value) {
              this.cbAcciones.selectedIndex(i);
              break;
            }
          }
        }
      } else {
        this.cbAcciones.selectedIndex(0);
      }
    } else {
      this.cbAcciones.selectedIndex(0);
      this.textoSeleccionado = '';
    }
  }

  onDragStart(event: any) {
    this.imageDelete = '/assets/images/delete_red.png';
  }

  onDragEnd(event: any) {
    this.imageDelete = '/assets/images/btnDelete.png';
    this.menuDel.clear(); // La vacío para que admita items repetidos
  }

  onChangeAccion(event: any) {
    const accionId = event.args.item.value;
    const item = this.menuFinal.getSelectedItem();
    // Cambio la acción en la opción seleccionada
    if (item) {
      item.value = accionId;
    }
    const accion = this.accionesHash.get(event.args.item.value);
    this.observacionesAccion =
      accion && accion.Observaciones != 'No hace nada'
        ? accion.Observaciones
        : '';
  }

  onChangeNewAccion(event: any) {
    const accion = this.accionesHash.get(event.args.item.value);
    this.observacionesAccion =
      accion && accion.Observaciones != 'No hace nada'
        ? accion.Observaciones
        : '';
  }

  onCrearOpcion() {
    this.opcVisible = !this.opcVisible;
    if (this.opcVisible) {
      this.initMenuOri();
      this.btnMas.val('Menos');
    } else {
      this.btnMas.val('Más');
    }
  }

  onBorrarMenu() {
    if (!this.menuSelec) {
      MainComponent.showError(
        'ATENCIÓN',
        'Seleccione un menú de la lista',
        2000,
      );
      return;
    }
    // El menú básico no se pude borrar
    if (this.menuSelec.Id === 1) {
      return;
    }
    this.modal.confirm({
      nzTitle: '<i>ATENCION</i>',
      nzContent: 'Quiere borrar el menú: ' + this.menuSelec.Nombre + ' ?',
      nzCentered: true,
      nzCancelText: 'CANCELAR',
      nzOkText: 'SI',
      nzOnOk: async () => {
        MainComponent.getInstance().showSuccess(
          'ATENCION',
          'Registro borrado',
          2000,
        );
        await this.menuService.deleteMenu(this.menuSelec.Id);
        for (let i = 0; i < this.menus.length; i++) {
          if (this.menuSelec.Id === this.menus[i].Id) {
            this.menus.splice(i, 1);
            break;
          }
        }
        this.menuSelec = null;
        this.grid.updatebounddata('cells');
        this.dataSourceFin = [];
        this.menuFinal.clear();
        this.ebNombre.val('');
        this.ebObserv.val('');
        this.cbAcciones.selectIndex(0);
        this.chbSoloMovisat.nativeElement.checked = false;
        this.opcVisible = false;
        this.btnMas.val('Más');
      },
    });
  }

  onGuardar() {
    if (!this.menuSelec) {
      MainComponent.showError(
        'ATENCIÓN',
        'Seleccione un menú de la lista',
        2000,
      );
      return;
    }
    this.menuSelec.Nombre = this.ebNombre.ngValue;
    this.menuSelec.Observaciones = this.ebObserv.ngValue;
    if (!this.menuSelec.Nombre || this.menuSelec.Nombre.length < 1) {
      MainComponent.showError('ATENCIÓN', 'Introduzca un nombre', 2000);
      return;
    }
    const menuItems = this.menuFinal.getItems();
    if (menuItems && menuItems.length > 0) {
      let oldLevel = 0;
      this.menuSelec.Opciones = [];
      const orden: number[] = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
      const ids = new Map<string, number>();
      // Asigno un id numérico a cada id hexa que genera el componente jqxTree
      // ya que la API solo entiende de id's numéricos
      let id = 1;
      menuItems.forEach((item: any) => {
        ids.set(item.id, id++);
      });
      menuItems.forEach((item: any) => {
        const mo = new MenuOptionsModel();
        if (oldLevel < item.level) {
          orden[item.level] = 1;
        }
        mo.Id = ids.get(item.id);
        mo.MenuId = this.menuSelec.Id;
        mo.PadreId = item.level > 0 ? ids.get(item.parentId) : 0;
        mo.Orden = orden[item.level]++;
        mo.TextoId = item.label;
        mo.AccionId = item.value;
        mo.SoloMovisat = item.checked;
        mo.Observaciones = '';
        mo.OpcionOriginalId = item.OpcionOriginalId
          ? item.OpcionOriginalId
          : this.idsOriginales.get(item.id);
        this.menuSelec.Opciones.push(mo);
        oldLevel = item.level;
      });
      this.modal.confirm({
        nzTitle: '<i>ATENCION</i>',
        nzContent: 'Quiere guardar el menú: ' + this.menuSelec.Nombre + ' ?',
        nzCentered: true,
        nzCancelText: 'CANCELAR',
        nzOkText: 'SI',
        nzOnOk: async () => {
          // console.log(JSON.stringify(this.menuSelec, null, 4));

          await this.menuService
            .saveMenuV2(this.menuSelec)
            .then((res) => {
              console.log(res);

              MainComponent.showSuccess(
                'ATENCIÓN',
                'Registro almacenado',
                2000,
              );
              for (let i = 0; i < this.menus.length; i++) {
                if (this.menuSelec.Id === this.menus[i].Id) {
                  this.menus[i] = { ...this.menuSelec };
                  break;
                }
              }
              this.menuSelec = null;
              this.grid.updatebounddata('cells');
              this.dataSourceFin = [];
              this.menuFinal.clear();
              this.ebNombre.val('');
              this.ebObserv.val('');
              this.cbAcciones.selectIndex(0);
              this.opcVisible = false;
              this.chbSoloMovisat.nativeElement.checked = false;
              this.verMenuOld = false;
              this.chbverMenuOld.nativeElement.checked = false;
              this.btnMas.val('Más');
              // Actualizo dos datos del menú original
              this.menusOld = [];
              this.menus.forEach((menu) => {
                this.menusOld.push(menu);
              });
              this.initMenuOld(this.rowIndexSelec);
            })
            .catch((error) => {
              console.log(error);
              MainComponent.showError('ATENCIÓN', error.error.error, 20000);
            });
        },
      });
    } else {
      MainComponent.showError('ATENCIÓN', 'El menú está vacio', 2000);
    }
  }

  onNuevaOpcion() {
    const itemSelec: any = this.menuFinal.getSelectedItem();
    if (!itemSelec) {
      MainComponent.showError(
        'ATENCIÓN',
        'Seleccione la posición en en menú donde quiere crear la nueva opción',
        2000,
      );
      return;
    }
    const texto = this.cbTextoOpcion.getItem(
      this.cbTextoOpcion.getSelectedIndex(),
    );
    const accion = this.cbAccionOpcion.getItem(
      this.cbAccionOpcion.getSelectedIndex(),
    );
    const newItem = { label: texto.value, value: accion.value };
    if (this.chbHermana.nativeElement.checked) {
      this.menuFinal.addAfter(newItem, itemSelec);
    } else {
      this.menuFinal.addTo(newItem, itemSelec);
    }
  }

  onChangeHermana(event: any) {
    if (event.target.checked) {
      this.chbHija.nativeElement.checked = false;
    } else {
      this.chbHija.nativeElement.checked = true;
    }
  }

  onChangeHija(event: any) {
    if (event.target.checked) {
      this.chbHermana.nativeElement.checked = false;
    } else {
      this.chbHermana.nativeElement.checked = true;
    }
  }

  onChangeSoloMovisat(event: any) {
    const item = this.menuFinal.getSelectedItem();
    // Cambio el valor del campo en la opción seleccionada
    if (item) {
      item.checked = event.target.checked;
    }
  }

  onChangeVerMenuOld(event: any) {
    this.verMenuOld = event.target.checked;
  }
}
